import clsx from "clsx"

function Card({ className, children, onClick }) {
  return (
    <div
      className={clsx(
        "flex flex-col gap-4 items-center sm:bg-white dark:sm:bg-olive-950 p-6 sm:rounded-2xl sm:border border-olive-950/15 dark:border-olive-100/15",
        className
      )}
      onClick={onClick}
    >
      {children}
    </div>
  )
}

export { Card }
